import React from "react";
import { NavLink } from "react-router-dom";

function AdminNav() {
  return (
    <header className="component-header">
      <div className="page-container">
        <nav className="nav-area">
          <NavLink to="/admin/usuarios" className="nav-link">
            <span className="material-symbols-outlined"> account_circle </span>{" "}
            Usuarios
          </NavLink>
          <NavLink to="/admin/empresas" className="nav-link">
            <span className="material-symbols-outlined">account_balance</span>{" "}
            Empresas
          </NavLink>
          <NavLink to="/admin/proveedores-firma" className="nav-link">
            <span className="material-symbols-outlined"> history_edu </span>{" "}
            Proveedores de Firma
          </NavLink>
          <NavLink to="/notificacion/configuracion-correo" className="nav-link">
            <span className="material-symbols-outlined">mail</span>{" "}
            Servidor de Correo
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default AdminNav;
